export function objectMap<T extends string>(
  obj: Partial<Record<T, any>>,
  cb: (item: any, key: T) => any,
): Record<T, any> | null | undefined {
  let mappedObject = {}
  for (let key in obj) {
    if (Object.hasOwn(obj, key)) {
      const item = obj[key]
      mappedObject = { ...mappedObject, [key]: cb(item, key) }
    }
  }
  return mappedObject as Record<T, any>
}

export function filterObjectFalsyValues<T>(obj: Record<any, any>): T {
  let o = Object.keys(obj)
    .filter((k) => !!obj[k])
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {})
  return o as T
}

export function filterObjectNullableValues<T>(obj: Record<any, any>): T {
  let o = Object.keys(obj)
    .filter((k) => obj[k] != null)
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {})
  return o as T
}

export function buildFormData(formData: FormData, data: any, parentKey?: string): void {
  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
    })
  } else {
    const value = data == null ? '' : data

    formData.append(parentKey as string, value)
  }
}

export function objectToFormData(data: any): FormData {
  const formData = new FormData()

  buildFormData(formData, data)

  return formData
}
